// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Array = require("rescript/lib/js/belt_Array.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var MM_substitution = require("../mm-utils/MM_substitution.res.js");
var MM_wrk_ctx_proc = require("./MM_wrk_ctx_proc.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.res.js");

var procName = "MM_wrk_search_asrt";

function reqToStr(req) {
  return "FindAssertions(label=\"" + req.label + "\", typ=" + String(req.typ) + ", " + ("pattern=" + Expln_utils_common.stringify(req.searchPattern) + ")");
}

function respToStr(resp) {
  if (resp.TAG === "OnProgress") {
    return "OnProgress(pct=" + String(resp._0) + ")";
  } else {
    return "SearchResult";
  }
}

function strToPatternModifier(str) {
  switch (str) {
    case "!" :
        return {
                TAG: "Ok",
                _0: "Exact"
              };
    case "+" :
        return {
                TAG: "Ok",
                _0: "Adj"
              };
    case "a" :
        return {
                TAG: "Ok",
                _0: "Asrt"
              };
    case "h" :
        return {
                TAG: "Ok",
                _0: "Hyp"
              };
    default:
      return {
              TAG: "Error",
              _0: "Cannot convert '" + str + "' to patternModifier"
            };
  }
}

function parseSearchStr(searchStr) {
  var result = [];
  var inFlags = false;
  var flags = [];
  var syms = [];
  var sym = [];
  var pos = {
    contents: 0
  };
  var maxPos = searchStr.length - 1 | 0;
  var err = {
    contents: undefined
  };
  var addPos = function (msg) {
    return msg + (" at position " + String(pos.contents + 1 | 0) + ".");
  };
  var setError = function (msg) {
    err.contents = addPos(msg);
  };
  var clearArray = function (arr) {
    arr.splice(0, arr.length);
  };
  var saveLastReadSymbol = function () {
    if (sym.length > 0) {
      syms.push(sym.join(""));
      return clearArray(sym);
    }
    
  };
  var commitStmtPattern = function () {
    saveLastReadSymbol();
    if (flags.length > 0 && syms.length === 0) {
      return setError("At least one symbol is expected");
    } else if (syms.length > 0) {
      result.push([
            flags.slice(),
            syms.slice()
          ]);
      clearArray(flags);
      return clearArray(syms);
    } else {
      return ;
    }
  };
  while(pos.contents <= maxPos && Core__Option.isNone(err.contents)) {
    var ch = searchStr.charAt(pos.contents);
    if (ch.trim() === "") {
      if (inFlags) {
        inFlags = false;
      } else {
        saveLastReadSymbol();
      }
    } else if (inFlags) {
      var msg = strToPatternModifier(ch);
      if (msg.TAG === "Ok") {
        flags.push(msg._0);
        if (flags.includes("Hyp") && flags.includes("Asrt")) {
          setError("A sub-pattern cannot be both a hypothesis and an assertion");
        } else if (flags.includes("Adj") && flags.includes("Exact")) {
          setError("A sub-pattern cannot be both Adjacent and Exact");
        }
        
      } else {
        setError(msg._0);
      }
    } else if (ch === "$") {
      commitStmtPattern();
      inFlags = true;
    } else {
      sym.push(ch);
    }
    pos.contents = pos.contents + 1 | 0;
  };
  var msg$1 = err.contents;
  if (msg$1 !== undefined) {
    return {
            TAG: "Error",
            _0: msg$1
          };
  }
  commitStmtPattern();
  var msg$2 = err.contents;
  if (msg$2 !== undefined) {
    return {
            TAG: "Error",
            _0: msg$2
          };
  } else if (result.length > 1 && result.some(function (param) {
          var flags = param[0];
          return !(flags.includes("Hyp") || flags.includes("Asrt"));
        })) {
    return {
            TAG: "Error",
            _0: "Each sub-pattern must be either a hypothesis or an assertion."
          };
  } else {
    return {
            TAG: "Ok",
            _0: result
          };
  }
}

function makeSearchPattern(searchStr, ctx) {
  var msg = parseSearchStr(searchStr);
  if (msg.TAG === "Ok") {
    return Core__Array.reduce(msg._0, {
                TAG: "Ok",
                _0: []
              }, (function (res, param) {
                  var syms = param[1];
                  if (res.TAG !== "Ok") {
                    return res;
                  }
                  var resArr = res._0;
                  var incorrectSymbol = syms.find(function (sym) {
                        return Core__Option.isNone(MM_context.ctxSymToInt(ctx, sym));
                      });
                  if (incorrectSymbol !== undefined) {
                    return {
                            TAG: "Error",
                            _0: "'" + incorrectSymbol + "' - is not a constant or a variable."
                          };
                  }
                  var varPat = MM_context.ctxSymsToIntsExn(ctx, syms);
                  var constPat = varPat.map(function (sym) {
                        if (sym < 0) {
                          return sym;
                        } else {
                          return MM_context.getTypeOfVarExn(ctx, sym);
                        }
                      });
                  resArr.push({
                        flags: param[0],
                        varPat: varPat,
                        constPat: constPat
                      });
                  return {
                          TAG: "Ok",
                          _0: resArr
                        };
                }));
  } else {
    return {
            TAG: "Error",
            _0: msg._0
          };
  }
}

function frmExprMatchesConstPatternAdj(frmExpr, constPat, varTypes, fromIdx) {
  var pIdx = 0;
  var maxPIdx = constPat.length - 1 | 0;
  var eIdx = fromIdx;
  var maxEIdx = frmExpr.length - 1 | 0;
  var match = true;
  while(match && pIdx <= maxPIdx && eIdx <= maxEIdx) {
    var frmSym = frmExpr[eIdx];
    var constPatSym = constPat[pIdx];
    match = frmSym < 0 && frmSym === constPatSym || frmSym >= 0 && varTypes[frmSym] === constPatSym;
    pIdx = pIdx + 1 | 0;
    eIdx = eIdx + 1 | 0;
  };
  if (match) {
    return pIdx > maxPIdx;
  } else {
    return false;
  }
}

function frmExprMatchesConstPattern(frmExpr, constPat, varTypes, flags) {
  var patLen = constPat.length;
  var frmExprLen = frmExpr.length;
  if (flags.includes("Exact")) {
    if (patLen === frmExprLen) {
      return frmExprMatchesConstPatternAdj(frmExpr, constPat, varTypes, 0);
    } else {
      return false;
    }
  }
  if (flags.includes("Adj")) {
    var found = false;
    var i = 0;
    var maxI = frmExprLen - patLen | 0;
    while(!found && i <= maxI) {
      found = frmExprMatchesConstPatternAdj(frmExpr, constPat, varTypes, i);
      i = i + 1 | 0;
    };
    return found;
  }
  var pIdx = 0;
  var aIdx = 0;
  while(pIdx < patLen && aIdx < frmExprLen) {
    var frmSym = frmExpr[aIdx];
    var patSym = constPat[pIdx];
    if (frmSym < 0 && frmSym === patSym || frmSym >= 0 && varTypes[frmSym] === patSym) {
      pIdx = pIdx + 1 | 0;
    }
    aIdx = aIdx + 1 | 0;
  };
  return pIdx === patLen;
}

function frmExprMatchesVarPatternAdj(frmExpr, varPat, constPat, varTypes, mapping, fromIdx) {
  var pIdx = 0;
  var maxPIdx = varPat.length - 1 | 0;
  var eIdx = fromIdx;
  var maxEIdx = frmExpr.length - 1 | 0;
  var match = true;
  while(match && pIdx <= maxPIdx && eIdx <= maxEIdx) {
    var frmSym = frmExpr[eIdx];
    var varPatSym = varPat[pIdx];
    if (frmSym < 0) {
      match = frmSym === varPatSym;
    } else {
      match = varTypes[frmSym] === constPat[pIdx];
      if (match && varPatSym >= 0) {
        var savedFrmSym = Belt_HashMapInt.get(mapping, varPatSym);
        if (savedFrmSym !== undefined) {
          match = savedFrmSym === frmSym;
        } else {
          Belt_HashMapInt.set(mapping, varPatSym, frmSym);
        }
      }
      
    }
    pIdx = pIdx + 1 | 0;
    eIdx = eIdx + 1 | 0;
  };
  Belt_HashMapInt.clear(mapping);
  if (match) {
    return pIdx > maxPIdx;
  } else {
    return false;
  }
}

function frmExprMatchesVarPatternRec(frmExpr, varPat, constPat, varTypes, mapping, pIdx, minAIdx) {
  if (pIdx === varPat.length) {
    return true;
  }
  var aIdx = {
    contents: minAIdx
  };
  var remainingMatches = function () {
    return frmExprMatchesVarPatternRec(frmExpr, varPat, constPat, varTypes, mapping, pIdx + 1 | 0, aIdx.contents + 1 | 0);
  };
  var found = false;
  var maxAIdx = frmExpr.length - (varPat.length - pIdx | 0) | 0;
  while(!found && aIdx.contents <= maxAIdx) {
    var frmSym = frmExpr[aIdx.contents];
    var varPatSym = varPat[pIdx];
    if (frmSym < 0 && frmSym === varPatSym) {
      found = remainingMatches();
    } else if (frmSym >= 0 && varTypes[frmSym] === constPat[pIdx]) {
      if (varPatSym < 0) {
        found = remainingMatches();
      } else {
        var savedFrmSym = Belt_HashMapInt.get(mapping, varPatSym);
        if (savedFrmSym !== undefined) {
          if (savedFrmSym === frmSym) {
            found = remainingMatches();
          }
          
        } else {
          Belt_HashMapInt.set(mapping, varPatSym, frmSym);
          found = remainingMatches();
          Belt_HashMapInt.remove(mapping, varPatSym);
        }
      }
    }
    aIdx.contents = aIdx.contents + 1 | 0;
  };
  return found;
}

function frmExprMatchesPattern(frmExpr, varPat, constPat, varTypes, flags, mapping) {
  if (frmExprMatchesConstPattern(frmExpr, constPat, varTypes, flags)) {
    var patLen = constPat.length;
    var frmExprLen = frmExpr.length;
    if (flags.includes("Exact")) {
      if (patLen === frmExprLen) {
        return frmExprMatchesVarPatternAdj(frmExpr, varPat, constPat, varTypes, mapping, 0);
      } else {
        return false;
      }
    }
    if (!flags.includes("Adj")) {
      return frmExprMatchesVarPatternRec(frmExpr, varPat, constPat, varTypes, mapping, 0, 0);
    }
    var found = false;
    var i = 0;
    var maxI = frmExprLen - patLen | 0;
    while(!found && i <= maxI) {
      found = frmExprMatchesVarPatternAdj(frmExpr, varPat, constPat, varTypes, mapping, i);
      i = i + 1 | 0;
    };
    return found;
  } else {
    return false;
  }
}

function frameMatchesPattern(frame, searchPattern, mapping) {
  if (!(searchPattern.length === 1 && !(searchPattern[0].flags.includes("Hyp") || searchPattern[0].flags.includes("Asrt")))) {
    var hasNonRepeatingPath = function (foundMatches, patIdx, path) {
      if (patIdx === foundMatches.length) {
        return true;
      } else {
        return foundMatches[patIdx].some(function (hypIdx) {
                    if (path.includes(hypIdx)) {
                      return false;
                    }
                    path.push(hypIdx);
                    var result = hasNonRepeatingPath(foundMatches, patIdx + 1 | 0, path);
                    path.pop();
                    return result;
                  });
      }
    };
    var varTypes = frame.varTypes;
    var asrtPatterns = searchPattern.filter(function (pat) {
          return pat.flags.includes("Asrt");
        });
    var match = asrtPatterns.find(function (pat) {
          return !frmExprMatchesPattern(frame.asrt, pat.varPat, pat.constPat, varTypes, pat.flags, mapping);
        });
    if (match !== undefined) {
      return false;
    }
    var hypPatterns = searchPattern.filter(function (pat) {
          return pat.flags.includes("Hyp");
        });
    if (hypPatterns.length === 0) {
      return true;
    }
    var eHyps = frame.hyps.filter(function (hyp) {
          return hyp.typ === "E";
        });
    if (eHyps.length < hypPatterns.length) {
      return false;
    }
    var foundMatches = Core__Array.reduce(hypPatterns, [], (function (found, pat) {
            if (found === undefined) {
              return ;
            }
            var matchedIdxs = eHyps.map(function (hyp, i) {
                      return [
                              hyp,
                              i
                            ];
                    }).filter(function (param) {
                    return frmExprMatchesPattern(param[0].expr, pat.varPat, pat.constPat, varTypes, pat.flags, mapping);
                  }).map(function (param) {
                  return param[1];
                });
            if (matchedIdxs.length === 0) {
              return ;
            } else {
              found.push(matchedIdxs);
              return found;
            }
          }));
    if (foundMatches !== undefined) {
      return hasNonRepeatingPath(foundMatches, 0, []);
    } else {
      return false;
    }
  }
  var pat = searchPattern[0];
  var varPat = pat.varPat;
  var constPat = pat.constPat;
  var flags = pat.flags;
  var varTypes$1 = frame.varTypes;
  if (frmExprMatchesPattern(frame.asrt, varPat, constPat, varTypes$1, flags, mapping)) {
    return true;
  } else {
    return Core__Array.reduce(frame.hyps, false, (function (res, hyp) {
                  if (res) {
                    return true;
                  } else if (hyp.typ === "E") {
                    return frmExprMatchesPattern(hyp.expr, varPat, constPat, varTypes$1, flags, mapping);
                  } else {
                    return false;
                  }
                }));
  }
}

function searchAssertions(settingsVer, settings, preCtxVer, preCtx, varsText, disjText, label, typ, searchPattern, onProgress) {
  return Expln_utils_promise.promise(function (resolve) {
              MM_wrk_ctx_proc.beginWorkerInteractionUsingCtx(settingsVer, settings, preCtxVer, preCtx, varsText, disjText, procName, {
                    TAG: "FindAssertions",
                    label: label.toLowerCase(),
                    typ: typ,
                    searchPattern: searchPattern
                  }, (function (resp, param, endWorkerInteraction) {
                      if (resp.TAG === "OnProgress") {
                        return onProgress(resp._0);
                      }
                      endWorkerInteraction();
                      resolve(resp.found);
                    }), false);
            });
}

function frameToStmtsDto(wrkCtx, frame) {
  var newDisj = MM_context.disjMake();
  Belt_MapInt.forEach(frame.disj, (function (n, ms) {
          Belt_SetInt.forEach(ms, (function (m) {
                  MM_context.disjAddPair(newDisj, n, m);
                }));
        }));
  var newDisjStr = [];
  MM_context.disjForEachArr(newDisj, undefined, undefined, undefined, undefined, (function (disjArr) {
          newDisjStr.push(MM_context.frmIntsToStrExn(wrkCtx, frame, disjArr));
        }));
  var stmts = [];
  var argLabels = [];
  frame.hyps.forEach(function (hyp) {
        if (hyp.typ !== "E") {
          return ;
        }
        var argLabel = hyp.label;
        argLabels.push(argLabel);
        stmts.push({
              label: argLabel,
              expr: hyp.expr,
              exprStr: MM_context.frmIntsToStrExn(wrkCtx, frame, hyp.expr),
              jstf: undefined,
              isProved: false
            });
      });
  stmts.push({
        label: frame.label,
        expr: frame.asrt,
        exprStr: MM_context.frmIntsToStrExn(wrkCtx, frame, frame.asrt),
        jstf: {
          args: argLabels,
          label: frame.label
        },
        isProved: false
      });
  return {
          newVars: Belt_Array.range(0, frame.numOfVars - 1 | 0),
          newVarTypes: frame.varTypes,
          newDisj: newDisj,
          newDisjStr: newDisjStr,
          stmts: stmts
        };
}

function doSearchAssertions(wrkCtx, frms, label, typ, searchPattern, onProgress) {
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, onProgress, undefined);
  var framesProcessed = {
    contents: 0
  };
  var numOfFrames = MM_substitution.frmsSize(frms);
  var mapping = Belt_HashMapInt.make(10);
  var results = [];
  var framesInDeclarationOrder = Expln_utils_common.sortInPlaceWith(MM_substitution.frmsSelect(frms, undefined, undefined), (function (a, b) {
          return a.frame.ord - b.frame.ord | 0;
        }));
  framesInDeclarationOrder.forEach(function (frm) {
        var frame = frm.frame;
        if (frame.label.toLowerCase().includes(label) && frame.asrt[0] === typ && frameMatchesPattern(frame, searchPattern, mapping)) {
          results.push(frameToStmtsDto(wrkCtx, frame));
        }
        framesProcessed.contents = framesProcessed.contents + 1;
        MM_progress_tracker.progressTrackerSetCurrPct(progressState, framesProcessed.contents / numOfFrames);
      });
  return results;
}

function processOnWorkerSide(req, sendToClient) {
  var results = doSearchAssertions(MM_wrk_ctx_proc.getWrkCtxExn(), MM_wrk_ctx_proc.getWrkFrmsExn(), req.label, req.typ, req.searchPattern, (function (pct) {
          sendToClient({
                TAG: "OnProgress",
                _0: pct
              });
        }));
  sendToClient({
        TAG: "SearchResult",
        found: results
      });
}

exports.procName = procName;
exports.parseSearchStr = parseSearchStr;
exports.makeSearchPattern = makeSearchPattern;
exports.doSearchAssertions = doSearchAssertions;
exports.searchAssertions = searchAssertions;
exports.frameToStmtsDto = frameToStmtsDto;
exports.processOnWorkerSide = processOnWorkerSide;
exports.frameMatchesPattern = frameMatchesPattern;
exports.reqToStr = reqToStr;
exports.respToStr = respToStr;
/* MM_context Not a pure module */
